import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {
    AbstractControl,
    UntypedFormControl,
    UntypedFormGroup,
    ValidationErrors
} from '@angular/forms';
import moment from 'moment';
import { fromEvent } from 'rxjs';
import { takeWhile, tap, throttleTime } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { EditGrid } from '../../../shared';
import { SelectItem, Table } from '../../../shared/efaact-primeng.module';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { AccountAllocation } from '../store';

@Component({
    selector: 'ef-cost-allocation',
    templateUrl: './cost-allocation.component.html',
    styleUrls: ['./cost-allocation.component.scss'],
    standalone: false
})
export class CostAllocationComponent
    extends EditGrid<AccountAllocation>
    implements OnInit, OnDestroy, OnChanges {
    showMultiUpdate = false;
    filteredItems: AccountAllocation[];
    private _expenseTypes: SelectItem[];
    @Input() public set expenseTypes(value: SelectItem[]) {
        this._expenseTypes = value;
    }
    public get expenseTypes(): SelectItem[] {
        return this._expenseTypes;
    }
    @Input() costCenters: SelectItem[] = [];
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('clearBulkUpdates', { read: ElementRef, static: true })
    clearBulkUpdatesButton: ElementRef;
    @ViewChild('applyBulk', { read: ElementRef, static: true })
    applyBulkButton: ElementRef;
    selectedExpenseTypes: string[] = [];
    moment: any;
    public showNA: boolean;
    showCostCenters: boolean;
    public updateFormGroup: UntypedFormGroup;
    dropdownItemHeight = environment.dropdownItemHeight;
    private active = true;
    constructor(
        private log: LoggingService,
        protected cdRef: ChangeDetectorRef
    ) {
        super();
        this.moment = moment;
        this.updateFormGroup = new UntypedFormGroup(
            {
                expenseType: new UntypedFormControl(),
                costCenter: new UntypedFormControl()
            },
            (ctrl: AbstractControl): ValidationErrors | null => {
                if (
                    ctrl.get('expenseType').value ||
                    ctrl.get('costCenter').value
                ) {
                    return null;
                }
                return {
                    invalid: true
                };
            }
        );
    }
    ngOnInit() {
        this.setupSubscriptions();
        if (this.costCenters && this.costCenters.length > 1) {
            this.showCostCenters = true;
        } else {
            this.showCostCenters = false;
        }
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes && changes.items && changes.items.currentValue) {
            this.updateFilter();
        }
    }
    clearBulk() {
        const controls = this.updateFormGroup.controls;
        controls['costCenter'].setValue(null);
        controls['expenseType'].setValue(null);
    }
    setupSubscriptions() {
        // fromEvent(this.clearBulkUpdatesButton.nativeElement, 'click')
        //     .pipe(
        //         takeWhile(x => this.active),
        //         throttleTime(1000),
        //         tap(() =>
        //             this.log.verbose({
        //                 type: 'UserAuthorizationsComponent:clearBulkUpdatesButton:click'
        //             })
        //         )
        //     )
        //     .subscribe(() => {
        //         this.clearBulk();
        //     });
        // fromEvent(this.applyBulkButton.nativeElement, 'click')
        //     .pipe(
        //         takeWhile(x => this.active),
        //         throttleTime(1000)
        //     )
        //     .subscribe(() => {
        //         this.applyBulkUpdate();
        //         this.clearBulk();
        //     });
    }
    applyBulkUpdate() {
        const controls = this.updateFormGroup.controls;
        const items: AccountAllocation[] =
            (this.dataTable && this.dataTable.selection) || [];
        const mapped = items.map(x => ({
            ...x,
            Costcenterid: controls['costCenter'].value || x.Costcenterid,
            Calctype: controls['expenseType'].value || x.Calctype
        }));
        this.log.verbose({
            type: 'CostAllocationComponent:applyBulkUpdate',
            controls,
            items,
            mapped
        });
        this.SaveItem.next(mapped);
        this.selected = [];
    }
    onRowEditCancel(item: AccountAllocation) {
        super.onRowEditCancel(item);
        this.updateFilter();
    }
    updateFilter() {
        this.filteredItems = this.showNA
            ? this.items
            : this.items &&
              this.items.filter(x => x.Calctype.toUpperCase() !== 'NA');
        this.log.verbose({
            type: 'CostAllocationComponent:updateFilter',
            accountAllocations: this.items,
            filteredAllocations: this.filteredItems
        });
        this.cdRef.detectChanges();
    }
    // onRowEditInit(item: AccountAllocation) {
    //     this.cloned[item.Accountlistid] = { ...item };
    //     this.editing = item;
    //     this.log.verbose({
    //         type: 'CostAllocationComponent:onRowEditInit',
    //         item,
    //         items: this.items,
    //         cloned: this.cloned,
    //         editing: this.editing
    //     });
    //     this.selected = [item];
    // }
    // onRowEditSave(item: AccountAllocation) {
    //     this.log.verbose({
    //         type: 'CostAllocationComponent:onRowEditSave',
    //         item,
    //         clonedAccountAllocations: this.cloned,
    //         selectedAccountAllocations: this.selected
    //     });
    //     item.Status.StatusCode = ResponseStatus.Loading;
    //     item.Status.Message = 'Saving';

    //     const items = [
    //         {
    //             ...item,
    //             Calctype: item.Calctype,
    //             Costcenterid: item.Costcenterid,
    //             Status: item.Status
    //         }
    //     ];
    //     this.SaveItem.next(items);
    //     delete this.cloned[item.Accountlistid];
    //     delete this.editing;
    //     this.selected = [];
    // }
    // onRowEditCancel(item: AccountAllocation) {
    //     this.log.verbose({
    //         type: 'CostAllocationComponent:onRowEditCancel',
    //         item,
    //         items: this.items,
    //         cloned: this.cloned
    //     });
    //     const index = this.items.findIndex(
    //         x => x.Accountlistid === item.Accountlistid
    //     );
    //     if (index >= 0) {
    //         this.items.splice(index, 1, this.cloned[item.Accountlistid]);
    //     }
    //     this.items = [...this.items];

    //     delete this.cloned[item.Accountlistid];
    //     delete this.editing;
    //     this.selected = [];
    // }
    // onStatusClick(item: AccountAllocation) {
    //     this.log.verbose({
    //         type: 'CostAllocationComponent:onStatusClick',
    //         item
    //     });
    //     this.ShowError.emit({ open: true, MsgEntityID: item.Accountlistid });
    // }
}
